<template>
  <div class="delete-account">
    <h2>Hesabı Sil</h2>
    <p>Bu işlem geri alınamaz. Hesabınızı silmek istediğinize emin misiniz?</p>

    <button class="btn danger" @click="confirmDelete">Hesabımı Sil</button>
  </div>
</template>

<script setup>
import { getToken, logout } from '@/utils/auth'
import { useRouter } from 'vue-router'
const baseURL = process.env.VUE_APP_API_URL

const router = useRouter()

async function confirmDelete() {
  if (!confirm('Bu işlem geri alınamaz. Hesabınızı silmek istediğinizden emin misiniz?')) return

  const res = await fetch(`${baseURL}/settings/account`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${getToken()}`
    }
  })

  const data = await res.json()
  if (res.ok) {
    alert(data.message || 'Hesabınız silindi.')
    logout()
    router.push('/')
  } else {
    alert(data.message || 'Bir hata oluştu.')
  }
}
</script>

<style scoped>
.delete-account {
  max-width: 600px;
  margin: auto;
}

.delete-account p {
  margin-bottom: 20px;
  color: #c0392b;
}

.btn.danger {
  padding: 10px 20px;
  background-color: #e74c3c;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}
</style>
